import moment from 'moment';
import React from 'react';
import { ReactComponent as AtRisk16 } from 'assets/svgs/at-risk.svg';
import { IconShell } from 'components/atoms/icon-shell';
import { Task } from 'data/tasks';
import { Container, IconContainer } from './task-card-content.styles';
import { TaskDuration } from './task-duration/task-duration';

export const TaskCardContent = ({ task }: { task: Task }) => {
  return (
    <Container>
      <IconContainer>
        {task.atRisk && (
          <IconShell icon={<AtRisk16 />} size="xsmall" dataTestId="atRisk" />
        )}
      </IconContainer>

      {task.dueDate && (
        <TaskDuration
          startDate={task.startDate ? moment(task.startDate) : null}
          dueDate={task.dueDate ? moment(task.dueDate) : null}
        />
      )}
    </Container>
  );
};
